import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AttachmentUploaderModule } from '@app/account/teacher-page/user-service-form/attachment-uploader/attachment-uploader.module';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';

import { FormControlsModule, RecordVideoModule } from '@app/shared';

import { VideoUploaderComponent } from '@shared/form-controls/video-uploader/video-uploader.component';
import { IconComponent } from '@shared/icon/icon.component';
import {
  OnUiBulletListModule,
  OnUiButtonModule,
  OnUiButtonTabModule,
  OnUiFormFieldErrorModule,
  OnUiFormStepModule,
  OnUiInputModule,
  OnUiRadioModule,
  OnUiSelectModule,
  OnUiTextareaModule,
} from 'onclass-ui';
import { TeacherSelectorModule } from './teacher-selector/teacher-selector.module';
import { UserServiceFormComponent } from './user-service-form.component';

@NgModule({
  declarations: [UserServiceFormComponent],
  exports: [UserServiceFormComponent],
  imports: [
    LocaleSharedModule,
    CommonModule,

    ReactiveFormsModule,
    OnUiBulletListModule,
    OnUiSelectModule,
    OnUiRadioModule,
    OnUiInputModule,
    FormControlsModule,
    OnUiButtonModule,
    AttachmentUploaderModule,
    OnUiFormStepModule,
    OnUiButtonTabModule,
    RecordVideoModule,
    OnUiFormFieldErrorModule,
    OnUiTextareaModule,
    RouterModule,
    TeacherSelectorModule,
    IconComponent,
    VideoUploaderComponent,
  ],
})
export class UserServiceFormModule {}
